import { styled } from "@mui/material/styles";

export const MainContainer = styled("div")({
  position: "relative",
  padding: "0 24px",
});

export const MainContainerSidebar = styled("div")({
  position: "relative",
  padding: 0,
  width: "100%",
  height: "100%",
});

export const FeatureLockedContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  inset: 0,
  zIndex: 1000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const FeatureLockedContainerSidebar = styled("div")(({ theme }) => ({
  position: "relative",
  zIndex: 1000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  padding: "24px 16px",
  boxSizing: "border-box",
}));

export const FeatureLockedCard = styled("div")({
  width: "60vw",
  height: "45dvh",
  backgroundColor: "#FFF",
  borderRadius: "8px",
  boxShadow: "0 0 6px 0 rgba(71, 84, 103, 0.20)",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  alignItems: "center",
  justifyContent: "center",
});

export const FeatureLockedCardSidebar = styled("div")({
  width: "100%",
  maxWidth: 420,
  backgroundColor: "#FFF",
  borderRadius: "8px",
  boxShadow: "0 0 6px 0 rgba(71, 84, 103, 0.20)",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  alignItems: "center",
  justifyContent: "center",
  padding: "32px 20px",
  boxSizing: "border-box",
});

export const ContactSupportContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
});

export const ContactSupportContainerSidebar = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "6px",
  // Override text sizing for the sidebar layout (children use larger default font sizes).
  "& p": {
    fontSize: "18px",
    lineHeight: "24px",
  },
});

export const RocketGif = styled("img")({
  width: "90px",
  height: "83px",
  marginBottom: "20px",
});

export const TitleText = styled("span")({
  fontFamily: "Manrope",
  fontSize: "29px",
  fontWeight: 600,
  lineHeight: "37px",
  textOverflow: "ellipsis",
  color: "#002445",
  marginBottom: "20px",
});

export const DescriptionText = styled("p")({
  fontFamily: "Manrope",
  fontSize: "22px",
  fontWeight: 600,
  lineHeight: "28px",
  textOverflow: "ellipsis",
  color: "#475467",
});

export const DescriptionSupportText = styled("p")({
  fontFamily: "Manrope",
  fontSize: "22px",
  fontWeight: 600,
  lineHeight: "28px",
  textOverflow: "ellipsis",
  textDecoration: "underline",
  textDecorationStyle: "solid",
  textDecorationSkipInk: "none",
  textDecorationThickness: "auto",
  textUnderlineOffset: "auto",
  color: "#2E90FA",
  cursor: "pointer",
});
